import { Command } from '@nest/internal-frontend';
import { useValidationResultDialog } from '@nest/uikit-react';
import { useMutation } from '@tanstack/react-query';
import { CheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useTerminalClient } from '../client-rpc-router';
import { useNumberParam } from '../helpers';

export const useCommandCompleteConsignmentNote = (): Command => {
	const navigate = useNavigate();
	const client = useTerminalClient();
	const consignmentNoteId = useNumberParam('consignmentNoteId');
	const completeMutation = useMutation({
		mutationFn: () => client.consignmentNotes.completeConsignmentNoteMutation.execute({ consignmentNoteId: consignmentNoteId! }),
		onSuccess: () => {
			toast.success('Nákladní list dokončen');
			navigate('/consignment-notes/carriers');
		}
	});

	useValidationResultDialog([completeMutation.error]);

	return {
		id: 'complete-consignment-note',
		label: 'Dokončit',
		icon: <CheckIcon className="h-4 w-4" />,
		shortcut: undefined,
		disabled: undefined,
		loading: completeMutation.isPending,
		run: async () => {
			completeMutation.mutateAsync();
		}
	};
};
